// use `self` instead of `window`, account for non-window contexts, such as in Web Workers
// @see https://developer.mozilla.org/en-US/docs/Web/API/Window/self
export var supportsTouchEvents = ('ontouchstart' in self);
export var supportsPointerEvents = !!self.PointerEvent;
export function isTouchEvent(event) {
  return supportsTouchEvents && event instanceof TouchEvent;
}
export function isMouseEvent(event) {
  return !self.MouseEvent || event instanceof MouseEvent && (!supportsPointerEvents || !(event instanceof self.PointerEvent));
}